import { render, staticRenderFns } from "./AuthorName.vue?vue&type=template&id=63eb93a2&"
import script from "./AuthorName.vue?vue&type=script&lang=js&"
export * from "./AuthorName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports